import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './assets/all.sass'; 
import AppRoutes from './components/AppRoutes.js';
import { HelmetProvider } from 'react-helmet-async';

//auth 
import { AuthProvider } from './context/authContext';
import { FirebaseProvider } from './context/firebaseContext';

//platform context
import { PlatformProvider } from './context/PlatformContext.js';

//academy context
import { AcademyProvider } from './context/academyContext';

// Import preloading function
import { preloadCriticalComponents } from './helpers/platformUtils';

// Import performance monitoring
import { initPerformanceMonitoring } from './utils/performance';

// Import service worker registration
import { register, handleServiceWorkerUpdate } from './utils/serviceWorker';
import AnalyticsListener from './components/AnalyticsListener';

function App() {
  useEffect(() => {
    // Preload critical components after the app mounts
    preloadCriticalComponents();
    
    
    
    // Initialize performance monitoring
    initPerformanceMonitoring();
    
    // Handle service worker updates
    handleServiceWorkerUpdate();
    
    // Preload commonly accessed routes
    const preloadCommonRoutes = () => {
      const commonRoutes = [
        '/study/astrology',
        '/study/tarot',
        '/study/numerology',
        '/tools/randomtarotcard',
        '/tools/randomcoinflipper'
      ];
      
      // Prefetch these routes after a delay
      setTimeout(() => {
        commonRoutes.forEach(route => {
          const link = document.createElement('link');
          link.rel = 'prefetch';
          link.href = route;
          document.head.appendChild(link);
        });
      }, 2000); // Wait 2 seconds after initial load
    };
    
    preloadCommonRoutes();
  }, []);

  // Register service worker
  useEffect(() => {
    register({
      onSuccess: (registration) => {
        // Service Worker registered successfully
      },
      onUpdate: (registration) => {
        // New service worker available
        if (window.confirm('New content is available! Reload to update?')) {
          window.location.reload();
        }
      }
    });
  }, []);

  return (
    <PlatformProvider>
    <AuthProvider>
      <FirebaseProvider>
        <AcademyProvider>
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <HelmetProvider>
                <div className="App">
                  <AnalyticsListener />
                  <AppRoutes /> 
                </div>
              </HelmetProvider>
            </Router>
        </AcademyProvider>
      </FirebaseProvider>
    </AuthProvider>
    </PlatformProvider>
  );
}

export default App;
